/**
 * Legal content — Privacy Policy table of contents (desktop): highlights the section being read.
 * Current section = the last <h2> whose top has passed 40% of the viewport (the first one before that).
 * Clicks on the items are handled by _utils.anchors() (smooth scroll to the heading).
 */
export const legalContent = () => {
    return new Promise((resolve) => {
        document.querySelectorAll('.legal-content--toc').forEach((section) => init(section));
        resolve();
    });
};

const init = (section) => {
    const links = [...section.querySelectorAll('.legal-content__toc-link')];
    const headings = links
        .map((link) => document.getElementById(link.hash.slice(1)))
        .filter(Boolean);
    if (headings.length !== links.length) return;

    let current = -1;
    let ticking = false;

    const update = () => {
        ticking = false;
        const line = window.innerHeight * 0.4;
        let index = 0;
        headings.forEach((heading, i) => {
            if (heading.getBoundingClientRect().top <= line) index = i;
        });

        // bottom of the page: the last sections can't reach the line → highlight the last one
        if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
            index = headings.length - 1;
        }

        if (index === current) return;
        current = index;
        links.forEach((link, i) => {
            const isActive = i === index;
            link.classList.toggle('is-active', isActive);
            if (isActive) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
        });
    };

    const onScroll = () => {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    };

    window.addEventListener('scroll', onScroll, {passive: true});
    window.addEventListener('resize', onScroll);
    update();
};
